export default __webpack_public_path__ + "static/media/pet-cat-default-icon.8b8fe565.svg";